/**
 * Notification delivery log row — `GET /account/notification-logs`.
 * One row per channel delivery (multichannel sends produce one row per
 * channel). `messageType` carries channel + transport, e.g.
 * "email (smtp)", "email (send grid)", "sms", "whatsapp", "webpush".
 */

export interface NotificationLogRecord {
  id: string | number;
  to?: string | null;
  from?: string | null;
  provider?: string | null;
  messageId?: string | null;
  messageType?: string | null;
  origin?: string | null;
  originAccount?: string | null;
  originReference?: string | null;
  sentAt?: string | null;
  status?: string | null;
  error?: string | null;
  errorCode?: string | null;
  webhookUrl?: string | null;
  webhookStatus?: string | null;
  webhookCalledAt?: string | null;
}

/** Canonical channel parsed from the messageType string. */
export const channelFromMessageType = (
  messageType?: string | null
): string | null => {
  const t = (messageType ?? "").toLowerCase();
  if (t.startsWith("email")) return "email";
  if (t.startsWith("sms")) return "sms";
  if (t.startsWith("whatsapp")) return "whatsapp";
  if (t.startsWith("telegram")) return "telegram";
  if (t.startsWith("webpush") || t.startsWith("web push")) return "webpush";
  if (t.startsWith("apppush") || t.startsWith("app push")) return "apppush";
  if (t.startsWith("slack")) return "slack";
  if (t.startsWith("teams")) return "teams";
  if (t.startsWith("discord")) return "discord";
  if (t.startsWith("googlechat")) return "googlechat";
  if (t.startsWith("wecom")) return "wecom";
  if (t.startsWith("mattermost")) return "mattermost";
  if (t.startsWith("rocketchat")) return "rocketchat";
  if (t.startsWith("viber")) return "viber";
  if (t.startsWith("line")) return "line";
  if (t.startsWith("inbox")) return "inbox";
  if (t.startsWith("webhook")) return "webhook";
  return null;
};
